import React, { memo } from "react";
import { useSelector } from "react-redux";

const Heading = () => {
  const { heading } = useSelector((state) => state.ui);
  return (
    <div className="heading_market  ">
      <h1 className="text_hade">{heading || "Dashboard"}</h1>
    </div>
  );
};

export default memo(Heading);
